import { RemoteGetPaginatedOrganizationTcesWaitingInstitutionSignature } from 'data/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetPaginatedOrganizationTcesWaitingInstitutionSignature =
  (): RemoteGetPaginatedOrganizationTcesWaitingInstitutionSignature => {
    return new RemoteGetPaginatedOrganizationTcesWaitingInstitutionSignature(
      makeApiUrlEntities(),
      makeAxiosHttpClient(),
    );
  };
